import script from "./Schedule.vue?vue&type=script&setup=true&lang=js"
export * from "./Schedule.vue?vue&type=script&setup=true&lang=js"

import "./Schedule.vue?vue&type=style&index=0&id=5cb3aa90&lang=scss"

const __exports__ = script;

export default __exports__